import { compose } from 'redux';

import { Loader } from '@hivebrite/design-system/Loader';

import PageCustomizablesApp from 'hb-react/frontoffice/apps/PageCustomizables';
import { withTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useTopicMenu } from 'hb-react/shared/apps/Topics/hooks/useTopicMenu';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

const TopicCustomPageContainer = ({
  currentUser,
  currentNetwork,
  subdomainNetworkUrl,
  topic,
  topicId,
  whitelabelURL,
}) => {
  const { appPages, isLoading } = useTopicMenu({ topic });

  if (isLoading) {
    return <Loader size={40} />;
  }

  return (
    <PageCustomizablesApp
      app={currentUser ? 'frontoffice' : 'publicoffice'}
      appPages={appPages}
      fetchPath={(pageId) =>
        dynamicTopicResourcePath(Routes.topic_page_path(topicId, pageId), {
          whitelabelURL,
          topicId,
        })
      }
      ids={{
        network: currentNetwork.id,
        topic: topicId,
        user: currentUser?.id,
      }}
      legacyContentClassName="container--centered soft-double--bottom soft--top soft--sides"
      redirectUrl={currentNetwork.network_config.redirect_url}
      subdomainNetworkUrl={subdomainNetworkUrl}
      topic={topic}
    />
  );
};

export default compose(
  withDefaultAppContexts,
  withTopicContext,
)(TopicCustomPageContainer);
